export default __webpack_public_path__ + "static/press-awards-omaha-3b7c5c397455330ccc7d1189e2747aa9.webp";